<pbc-sorter [config]="FelderSorterConfig" [sorter]="felder.sorter$ | async" (sorterChange)="felder.sorter$.next($event)"></pbc-sorter>
